export enum WebsiteThemes {
  THEME_WHITE = 'd508',
  THEME_NATURE = '405a',
  THEME_CYBERPUNK = 'd52d',
  THEME_CAMEL = 'd53d',
  THEME_UK = 'w1h9',
  THEME_BLACK = 'h891',
}

/* Список сайтов, которые нельзя вводить без дополнительного пути */
export const BLOCKED_MAIN_PAGE_WEBSITES = [
  'adultsearch.com',
  'eros.com',
  'slixa.com',
  'tryst.link',
  'theeroticreview.com',
  'hot.com',
  'megapersonals.eu',
  'facebook.com',
  'harlothub.com',
  'google.com',
  'mintboys.com',
  'friendboy.pro',
  'massagerepublic.com',
  'birchplace.com',
  'esa.co.za',
  'preferred411.com',
  'rent.men',
  'skipthegames.com',
  'ts4rent.eu',
  'tsescorts.com',
];

export enum UserRoles {
  PPC = 1,
  Subscription = 2,
}

/**
 * Virtual user group, can include multiple roles
 * @see /hotsearch/enums/HsUserRoleEnum.php
 */
export const UserRolesAgency = [UserRoles.ESCORT_AGENCY];
export const UserRolesIndependent = [UserRoles.INDEPENDENT_ESCORT, UserRoles.BODY_RUBS];
export const UserRolesBusinessOwner = [UserRoles.MASSAGE_PARLOR_OWNER, UserRoles.BUSINESS_OWNER];

export enum PromotionTypes {
  Text = 5,
  Url = 6,
  Image = 7,
  MobileMenu = 8,
  TopSpot = 10,
}

export enum PromotionTextTypes {
  Text = 'text',
  Image = 'image',
  Url = 'url',
  TopSpot = 'top-spot',
  MobileMenu = 'mobile-menu',
}

export enum ScreenBreakpoints {
  Mobile = 768,
}

export const mediaQueries = {
  small: `(max-width: ${ScreenBreakpoints.Mobile - 1}px)`,
  large: `(min-width: ${ScreenBreakpoints.Mobile}px)`,
};

export const websiteRegexp =
  /^(?:(?:(?:https?|http):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,200})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,10})?(?:[/?#]\S*)?$/i;

export const onlyFansRegexp = /^https*:\/\/(www.)*onlyfans.com\//;

export const WorkerCookieName = 'hot_com';
export const EngineCookieName = 'analyzer';

export enum EngineCookieValues {
  Query = 'query',
  Ai = 'ai',
}
